import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const SectionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	background-color: ${colors.white};
	margin: 1% 0 0 0;
	padding: 0 2%;
`;

export const Breadcrumbs = styled.div`
	display: flex;
	align-items: center;
	font-weight: 500;
	font-size: 12px;
	letter-spacing: 0.3px;
	color: ${colors.grey6};
	span {
		cursor: pointer;
		font-size: 12px;
	}
	span:hover {
		cursor: pointer;
		color: ${colors.grey9};
	}
`;

export const NoData = styled.div`
	color: ${colors.grey7};
	font-size: 16px;
	letter-spacing: 0.3px;
	padding: 32px 0 32px 4px;
`;

export const Header = styled.div`
	display: flex;
	align-items: flex-end;
`;

export const FilterWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
  justify-content: flex-start;
	margin: 1% 0 0;
  > div {
		> div {
			> div {
        border-radius: 0;
      }
		}
  .ap-button-main {
    height: 32px;
  }
`;

export const SingleFilterWrapper = styled.div``;

export const BreakdownWrapper = styled.div`
	display: flex;
	flex-wrap: nowrap;
	flex-direction: row;
	align-items: center;
	gap: 5px;
	margin: 0.5% 0 0;
`;

export const BreakdownByWrapper = styled.div`
	font-weight: 400;
	font-size: 13px;
	line-height: 16px;
	color: ${colors.grey5};
`;
